<template>
  <div class="footerNav" id="footerNav" v-if="!RENMINWANG_TYPE">
    <ul>
      <v-touch tag="li" v-bind:class="{'selected':curPage=='extendingCenter'}" v-on:tap="toPage('/extendingCenter')">
        <i class="index" :class="{'is-kwai': !isTikTok}"></i>
        <p class="text">推广首页</p>
      </v-touch>
      <v-touch v-if="isTikTok" tag="li" v-bind:class="{'selected':curPage=='addData'}" v-on:tap="toPage('/addData')">
        <i class="add"></i>
        <p class="text">广告数据</p>
      </v-touch>
      <v-touch tag="li" v-bind:class="{'selected':curPage=='myEarnings'}" v-on:tap="toPage('/myEarnings')">
        <i class="mine" :class="{'is-kwai': !isTikTok}"></i>
        <p class="text">个人中心</p>
      </v-touch>
    </ul>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex';

export default {
  name: "footerNav",
  components: {
  },
  computed: {
    routerPath () {
      return this.$route.path
    },
    ...mapState([
      'channelId',
    ]),
    ...mapGetters(['extendPlatform']),
    isTikTok () {
      return this.extendPlatform === 'tiktok'
    },
  },
  data() {
    return {
      curPage: 'index',
      showQrcode: false
    }
  },
  mounted() {
    this.iconSwitch();
  },
  watch: {
    routerPath: function () {
      this.iconSwitch();
    }
  },
  methods: {
    iconSwitch(routerName) {
      if (!!routerName) {
        this.$data.curPage = routerName;
      } else {
        this.$data.curPage = this.$route.name;
      }
    },
    showQrCode() {
      event.stopPropagation();
      event.preventDefault();
      this.$data.showQrcode = true;
    },
    hideQrCode() {
      this.$data.showQrcode = false;
      event.stopPropagation();
      event.preventDefault();
    },
    toPage(routerPath) {
      const that = this;
      // 免登陆切换路径
      let newPath = (routerPath == '/mine/0')&&that.CHANNEL_NOT_LOGIN ? '/noLoginCenter' : routerPath
      let query = {
        channelId: that.channelId
      }
      if (that.$route.query.force) {
          query.force = that.$route.query.force
      }
      that.iconSwitch(newPath);
      if (that.$route.path == newPath) {
        location.reload()
      } else {
        that.$router.push({
          path: newPath,
          query: query
        })
      }
    },
    stopScroll() {
      event.preventDefault();
      event.stopPropagation();
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/function";

.footerNav {
  height: topx(98rem);
  ul {
    width: 10rem;
    height: topx(98rem);
    position: fixed;
    z-index: 3;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    background: #FFFFFF;
    box-shadow: 0 topx(-10rem) topx(20rem) topx(-12rem) #E5E5E5;
    padding-bottom: env(safe-area-inset-bottom);
  }
  li {
    flex: 1 1 0;
    font-size: topx(24rem);
    font-weight: normal;
    color: #999999;
    line-height: topx(33rem);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    &.selected {
      font-weight: bold;
      color: #613E1F;
      .index {
        background: url('../../assets/toutiao/footer/icon-home_on.png') no-repeat center;
        background-size: 100% 100%;

        &.is-kwai {
          background: url('../../assets/toutiao/footer/icon-kwai_on.png') no-repeat center;
          background-size: 100% 100%;
        }
      }
      .mine {
        background: url('../../assets/toutiao/footer/icon-mine_on.png') no-repeat center;
        background-size: 100% 100%;

        &.is-kwai {
          background: url('../../assets/toutiao/footer/icon-mine_on-kwai.png') no-repeat center;
          background-size: 100% 100%;
        }
      }
      .add {
        background: url('../../assets/toutiao/footer/icon-add_on.png') no-repeat center;
        background-size: 100% 100%;
      }
    }
    a {
      color: inherit;
    }
    i {
      display: inline-block;
      width: topx(50rem);
      height: topx(50rem);
      margin-bottom: topx(5rem);
      &.index {
        background: url('../../assets/toutiao/footer/icon-home.png') no-repeat center;
        background-size: 100% 100%;
      }
      &.mine {
        background: url('../../assets/toutiao/footer/icon-mine.png') no-repeat center;
        background-size: 100% 100%;
      }
      &.add {
        background: url('../../assets/toutiao/footer/icon-add.png') no-repeat center;
        background-size: 100% 100%;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/toutiao/footerNav.vue